import { useAuth } from "@clerk/clerk-react"
import { useQuery } from "@tanstack/react-query"
import { fetchAccount } from "../api/account"

export function useRefinedAccess(enabled = true) {
  const { isSignedIn, isLoaded, userId } = useAuth()
  const query = useQuery({
    // The QueryClient is account/org-scoped by App. Keep the key stable while
    // the first /me response pins its backend-selected organization header.
    queryKey: ["me", userId],
    queryFn: fetchAccount,
    enabled: enabled && !!isLoaded && !!isSignedIn,
    retry: false,
    staleTime: 0,
  })
  // Any failed refresh revokes UI authority; stale successful data is not permission.
  return {
    account: query.isError ? undefined : query.data,
    accessDenied: query.isError,
    isLoading: enabled && query.isPending,
    error: query.error,
    retry: query.refetch,
  }
}
